<template>
    <div v-if="paymentMethods">
        <title-and-edit :class="type == 'payment' ? 'px-3 font-weight-thin' : ''" :currentViewTitle="type == 'payment' ? 'Hvordan vil du betale?' : 'Betalingsmetoder'" :layout="layout"/>
        <div class="profile__container--content__payment-methods primary-font mt-5">
            <div v-if="cardConfig.active">
                <hr v-if="type == 'payment'" :class="`profile__container--navigation__${layout == 'portal' ? 'portal-linebreak' : 'linebreak'}`"/>
                <payment-list-item 
                    :title="cardConfig.title" 
                    @selectPaymentMethod="$emit('selectPaymentMethod', cardConfig.type)" 
                    :isSelected="selectedMethod === cardConfig.type" 
                    :isPayment="type == 'payment'" 
                    :icon="visaIcon" 
                    :description="type == 'payment' ? cardConfig.feePaymentDescription : ''"
                    >
                    <cards :layout="layout" :model="defaultPaymentMethod === cardConfig.type" @update="x => updatePaymentMethod(x)" class="pr-3 pl-10 pt-3"></cards>
                </payment-list-item>
                <hr :class="`profile__container--navigation__${layout == 'portal' ? 'portal-linebreak' : 'linebreak'}`"/>
            </div>
            <div v-if="vippsConfig && vippsConfig.active">
                <payment-list-item 
                    :title="vippsConfig.title" 
                    @selectPaymentMethod="$emit('selectPaymentMethod', vippsConfig.type)" 
                    :isSelected="selectedMethod === vippsConfig.type" 
                    :isPayment="type == 'payment'" 
                    :icon="vippsIcon" 
                    :description="type == 'payment' ? vippsConfig.feePaymentDescription : ''"
                    >
                    <vipps :model="defaultPaymentMethod === vippsConfig.type" @update="x => updatePaymentMethod(x)" class="pr-3 pl-10"></vipps>
                </payment-list-item>
                <hr :class="`profile__container--navigation__${layout == 'portal' ? 'portal-linebreak' : 'linebreak'}`"/>
            </div>
            <div v-if="klarnaConfig && klarnaConfig.active">
                <payment-list-item 
                    :title="klarnaConfig.title" 
                    @selectPaymentMethod="$emit('selectPaymentMethod', klarnaConfig.type)" 
                    :isSelected="selectedMethod === klarnaConfig.type" 
                    :isPayment="type == 'payment'" 
                    :icon="klarnaIcon" 
                    :description="type == 'payment' ? klarnaConfig.feePaymentDescription : ''"
                    >
                    <pay-later :model="defaultPaymentMethod === klarnaConfig.type" @update="x => updatePaymentMethod(x)" class="pr-3 pl-10"></pay-later>
                </payment-list-item>
                <hr :class="`profile__container--navigation__${layout == 'portal' ? 'portal-linebreak' : 'linebreak'}`"/>
            </div>
            <div v-if="appleConfig && appleConfig.active && ((type === 'payment' && isIos) || type === 'profile')">
                <payment-list-item 
                    :title="appleConfig.title" 
                    @selectPaymentMethod="$emit('selectPaymentMethod', appleConfig.type)" 
                    :isSelected="selectedMethod === appleConfig.type" 
                    :isPayment="type == 'payment'" 
                    :icon="applePayIcon" 
                    :description="type == 'payment' ? appleConfig.feePaymentDescription : ''"
                    >
                    <apple-pay :model="defaultPaymentMethod === appleConfig.type" @update="x => updatePaymentMethod(x)" class="pr-3 pl-10"></apple-pay>
                </payment-list-item>
                <hr :class="`profile__container--navigation__${layout == 'portal' ? 'portal-linebreak' : 'linebreak'}`"/>
            </div>
            <div v-if="googleConfig && googleConfig.active">
                <payment-list-item 
                    :title="googleConfig.title" 
                    @selectPaymentMethod="$emit('selectPaymentMethod', googleConfig.type)" 
                    :isSelected="selectedMethod === googleConfig.type" 
                    :isPayment="type == 'payment'" 
                    :icon="googlePayIcon" 
                    :description="type == 'payment' ? googleConfig.feePaymentDescription : ''"
                    >
                    <google-pay :model="defaultPaymentMethod === googleConfig.type" @update="x => updatePaymentMethod(x)" class="pr-3 pl-10"></google-pay>
                </payment-list-item>
                <hr :class="`profile__container--navigation__${layout == 'portal' ? 'portal-linebreak' : 'linebreak'}`"/>
            </div>
        </div>
    </div>
</template>

<script>
import { TitleAndEdit } from '../../../Common/CommonComponents'
import { Cards, GooglePay, ApplePay, PayLater, Vipps, PaymentListItem } from './components'
import ProfileSvc from '../../../../services/profile-svc';
import PaymentSvc from '../../../../services/payment-svc';
let paymentSvc = null;
let profileSvc = null;

export default {
    components: { PaymentListItem, Cards, ApplePay, GooglePay, PayLater, Vipps, TitleAndEdit },
    props: {
        user: {
            required: true,
            default: '',
            type: Object,
        },
        layout: {
            required: false,
            default: 'chain',
            type: String
        },
        type: {
            required: false,
            default: 'profile' 
        },
        selectedMethod: {},
    },
    methods: {
        async updatePaymentMethod(paymentType) {
            this.defaultPaymentMethod = await profileSvc.UpdateDefaultPaymentMethod(process.env.VUE_APP_FIXIT_NO_BOOKING_URL, this.defaultPaymentMethod === paymentType ? null : paymentType);
        },
    },
    computed: {
        cardConfig() {
            return this.paymentMethods.find(x => x.type == 0)
        },
        vippsConfig() {
            return this.paymentMethods.find(x => x.type == 1)
        },
        klarnaConfig() {
            return this.paymentMethods.find(x => x.type == 5)
        },
        appleConfig() {
            return this.paymentMethods.find(x => x.type == 6)
        },
        googleConfig() {
            return this.paymentMethods.find(x => x.type == 7)
        },
        isIos() {
            const ua = window.navigator.userAgent;
            const iosDevice = ua.match(/iPad/i) || ua.match(/iPhone/i);
            const isIos = iosDevice?.toString() == 'iPad' || iosDevice?.toString() == 'iPhone';
            const isSafari = /^((?!chrome|android).)*safari/i.test(ua);
            return (isIos || isSafari)
        }
    },
    data() {
        return {
            vippsIcon: require("../../../../assets/img/vipps-logo-orange.png"),
            visaIcon: require("../../../../assets/img/cards-logo.png"),
            applePayIcon: require("../../../../assets/img/logo_apple_pay.svg"),
            googlePayIcon: require("../../../../assets/img/logo_google_pay.svg"),
            klarnaIcon: require("../../../../assets/img/logo_klarna.svg"),
            edit: false,
            defaultPaymentMethod: 100,
            paymentMethods: null
        }
    },
    async mounted() {
        profileSvc = await ProfileSvc(this.$axios);
		paymentSvc = await PaymentSvc(this.$axios);
        this.defaultPaymentMethod = await profileSvc.GetDefaultPaymentMethod(process.env.VUE_APP_FIXIT_NO_BOOKING_URL);
        this.paymentMethods = await paymentSvc.GetPaymentMethodsConfig(this.$route.params.siteId ? this.$route.params.siteId : 0)
	},
    beforeDestroy() {
		paymentSvc = null
        profileSvc = null
	}
}
</script>